import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=28a3c8c3&scoped=true&"
import script from "./LeftPanel.vue?vue&type=script&lang=js&"
export * from "./LeftPanel.vue?vue&type=script&lang=js&"
import style0 from "./LeftPanel.vue?vue&type=style&index=0&id=28a3c8c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3c8c3",
  null
  
)

export default component.exports